export default __webpack_public_path__ + "static/18-65473cdc0a97174ccc0b9f5621bbb7f1.jpg";